// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/sass/style.scss
// module id = 340
// module chunks = 0